/**
 * Страница «Проекты» (эпик US-05, раздел после «Аналитики»).
 *
 * Свёрстаны подразделы «Инфраструктурные проекты» (US-05.1) — открыт по
 * умолчанию (FR-1.1) — и «Инвестиционные проекты» (US-05.2).
 *
 * Ряд чипов-подразделов временно скрыт (решение от 11.08.2026): пока виден
 * только инфраструктурный подраздел. Чтобы вернуть переключение —
 * раскомментировать блок ниже и восстановить setFilter/t/cn.
 * Видимость «Инвестиционных» задаёт супер-админ (US-05.2 FR-3.1,
 * useModulePresent, default-visible).
 */
import { useState } from 'react';

import { InfrastructureProjectsSection } from './components/InfrastructureProjectsSection';
import { InvestmentProjectsSection } from './components/InvestmentProjectsSection';
import { useModulePresent } from '../../hooks/useModulePresent';

export type ProjectsFilter = 'infrastructure' | 'investment';

export const ProjectsPage = () => {
  const [filter] = useState<ProjectsFilter>('infrastructure');

  const showInvestment = useModulePresent('projects.investment');

  return (
    <div className="space-y-4 p-5">
      {/* <div
        className="flex items-center gap-2.5 overflow-x-auto pb-1"
        data-testid="projects-filters"
      >
        {filters.map((key) => (
          <button
            key={key}
            type="button"
            aria-pressed={filter === key}
            onClick={() => setFilter(key)}
            data-testid={`projects-filter-${key}`}
            className={cn(
              'shrink-0 whitespace-nowrap rounded-xl px-2 py-1.5 text-sm font-medium transition-colors',
              filter === key
                ? 'bg-text text-text-inverted'
                : 'bg-surface-muted text-text hover:bg-surface-border',
            )}
          >
            {t(`projects.subtabs.${key}`)}
          </button>
        ))}
      </div> */}

      {filter === 'infrastructure' && <InfrastructureProjectsSection />}
      {filter === 'investment' && showInvestment && (
        <InvestmentProjectsSection />
      )}
    </div>
  );
};
